import botIcon1 from './assets/bot-icons/bot-svg-1.svg';

export const Constants = {
    app: {
        CONNECTION_ALERT_ID: 'connection-alert',
        importTypes: '.txt, .pdf, .docx, .pptx, .md, .jpg, .jpeg, .png, .xlsx, .csv',
    },
    msal: {
        method: 'redirect',
        cache: {
            cacheLocation: 'localStorage',
            storeAuthStateInCookie: false,
        },
        semanticKernelScopes: ['openid', 'offline_access', 'profile'],
        msGraphAppScopes: ['openid', 'profile', 'offline_access'],
        tempRemove: ['User.ReadBasic.All'],
    },
    bot: {
        profile: {
            id: 'bot',
            fullName: import.meta.env.VITE_APP_BOT_NAME ?? 'eya',
            emailAddress: '',
            photo: botIcon1,
        },
        fileExtension: 'skcb',
        typingIndicatorTimeoutMs: 5000,
    },
    BATCH_REQUEST_LIMIT: 20,
    plugins: {
        // For a list of Microsoft Graph permissions, see https://learn.microsoft.com/en-us/graph/permissions-reference.
        // Your application registration will need to be granted these permissions in Azure Active Directory.
        msGraphScopes: ['Calendars.Read', 'Mail.Read', 'Mail.Send', 'Tasks.ReadWrite', 'User.Read'],
    },
    debug: {
        root: 'pcgpt-frontend',
    },
    useBrowserCache: {
        getBucketsAsync: true,
        getBucketSourcesAsync: true,
        getConfigSingleValueAsync: true,
        getConfigMultipleValues: true,
        getConfigDropdownValues: true,
    },
};
